import {
  MOBILE_AIRPORT_SHEET_KEYBOARD_INSET_VAR,
  MOBILE_AIRPORT_SHEET_KEYBOARD_OPEN_CLASS,
  MOBILE_AIRPORT_SHEET_KEYBOARD_OPEN_INSET_PX,
  MOBILE_AIRPORT_SHEET_VV_HEIGHT_VAR,
} from './mobileAirportSheetKeyboard.constants';

/**
 * Pins a bottom airport sheet to the visual viewport so the list stays
 * above the mobile keyboard while the user types.
 */
class MobileAirportSheetKeyboard {
  constructor(element) {
    this.element = element;
    this.sync = this.sync.bind(this);
  }

  attach() {
    const vv = typeof window !== 'undefined' ? window.visualViewport : null;
    vv?.addEventListener('resize', this.sync);
    vv?.addEventListener('scroll', this.sync);
    window.addEventListener('resize', this.sync);
    this.sync();
  }

  detach() {
    const vv = typeof window !== 'undefined' ? window.visualViewport : null;
    vv?.removeEventListener('resize', this.sync);
    vv?.removeEventListener('scroll', this.sync);
    window.removeEventListener('resize', this.sync);
    if (!this.element) return;
    this.element.style.removeProperty(MOBILE_AIRPORT_SHEET_VV_HEIGHT_VAR);
    this.element.style.removeProperty(MOBILE_AIRPORT_SHEET_KEYBOARD_INSET_VAR);
    this.element.classList.remove(MOBILE_AIRPORT_SHEET_KEYBOARD_OPEN_CLASS);
  }

  sync() {
    if (!this.element) return;
    const layoutHeight = window.innerHeight || 0;
    const vv = window.visualViewport;
    const visibleHeight = vv?.height || layoutHeight;
    const offsetTop = vv?.offsetTop || 0;
    const inset = Math.max(0, Math.round(layoutHeight - visibleHeight - offsetTop));
    const sheetHeight = Math.max(0, Math.round(visibleHeight));

    this.element.style.setProperty(MOBILE_AIRPORT_SHEET_VV_HEIGHT_VAR, `${sheetHeight}px`);
    this.element.style.setProperty(MOBILE_AIRPORT_SHEET_KEYBOARD_INSET_VAR, `${inset}px`);
    this.element.classList.toggle(
      MOBILE_AIRPORT_SHEET_KEYBOARD_OPEN_CLASS,
      inset >= MOBILE_AIRPORT_SHEET_KEYBOARD_OPEN_INSET_PX,
    );
  }
}

export default MobileAirportSheetKeyboard;
